export function onWindowResize(trigger: () => void): void {
  window.addEventListener('resize', trigger);
}

export function checkWindowCutoff(width: number): boolean {
  return window.innerWidth > width;
}
